import LeanerTbl from "./LeanerTbl.js";
import LeanerAssingmentTbl from "./LeanerAssingmentTbl.js";
import LeanerScomTbl from "./LeanerScomTbl.js";
import Leanerdetails from "./Leanerdetails.js";

export default class LearnerReport extends React.Component{
  constructor(props){
    super(props);
    this.box   = React.createRef();
    window.leanerDropdown = this.leanerDropdown;
    this.state = { isOPenDropDown:false,learnerid: this.props['match']['params']['id'], learnercourseid: this.props['match']['params']['cid'], activeTabs: 'testTab', leanerDropdown: this.props['match']['params']['cid']};//testTab
  }

  leanerTestTabs = () => {
    return(<div className="tab-pane fade showed active" id="testreport" role="tabpanel" aria-labelledby="test-tab">
      <div className="bc-datatable-holder leaner-report-prgress-details-sec">
        <LeanerTbl data={[]} learnerid={this.state.learnerid} learnerCourseid={this.state.learnercourseid} leanerDropdown={this.state.leanerDropdown} archiveid={this.state.id}/>
      </div>
    </div>
    );
  }

  leanerAssingmentTabs = () => {
    return (<div className="tab-pane fade  showed active" id="assignmentreport" role="tabpanel" aria-labelledby="assignment">
      <div className="bc-datatable-holder leaner-report-prgress-details-sec">
        <LeanerAssingmentTbl data={[]} learnerid={this.state.learnerid} learnerCourseid={this.state.leanerDropdown} />
      </div>
    </div>
    );
  }
  leanerScomTabs = () => {
    return (<div className="tab-pane fade  showed active" id="assignmentreport" role="tabpanel" aria-labelledby="assignment">
      <div className="bc-datatable-holder leaner-report-prgress-details-sec">
        <LeanerScomTbl data={[]} learnerid={this.state.learnerid} learnerCourseid={this.state.leanerDropdown} />
      </div>
    </div>
    );
  }

  exportSummary = () => {
    location.href = admin_url + 'Archive_consolidate_report/leaner_export/' + this.state.learnerid + '/' + this.state.leanerDropdown+__setSsAuthUrl;
  }

  leanerDropdown = (e) => {
    this.setState({ leanerDropdown: e });
    this.setState({ activeTabs: 'testTab',isOPenDropDown:false });
    document.removeEventListener('click', this.handleOutsideClick);

    location.href = admin_url + `Archive_consolidate_report${__setSsAuthUrl}#/learner_report/${this.state.learnerid}/${e}`;
  }
componentDidMount(){
  
}
componentWillUnmount(){
  
}

SetIsopenToggle = ()=>{
  this.setState({isOPenDropDown:!this.state.isOPenDropDown},()=>{
    document.addEventListener('click', this.handleOutsideClick);
  });
}

handleOutsideClick = (event) => {
  if (this.box && !this.box.current.contains(event.target)) {
    document.removeEventListener('click', this.handleOutsideClick);
    this.setState({isOPenDropDown:!this.state.isOPenDropDown});
  }
}

render(){   
return (
<section className="content-wrap learner-progres-report-sec">
  <div className="container-fluid">
    <div className="leaner-sltd-header rTable w-100">
      <div className="rTableRow-align">
      
        <div className="align-center d-flex rTableCell">
          <span className="leaner-back-btn">
            <a href={`${admin_url}archive_consolidate_report${__setSsAuthUrl}#/`}>
            <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 23 24.241">
              <g id="Icon_feather-arrow-left" data-name="Icon feather-arrow-left" transform="translate(1.5 2.121)">
                <path id="Path_221" data-name="Path 221" d="M27.5,18H7.5" transform="translate(-7.5 -8)" fill="none" stroke="#2e3e4e" strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} />
                <path id="Path_222" data-name="Path 222" d="M18,27.5,7.5,17.5,18,7.5" transform="translate(-7.5 -7.5)" fill="none" stroke="#2e3e4e" strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} />
              </g>
            </svg>
            </a>
          </span>

          <div className="leaner-user-id">
            <span className="leaner-user-idtxt" id="learnerProfileImage"></span>
            <div className="leaner-idtxt">
              <h4 id="leanerName"></h4>
              <p id="leanerEmail"></p>
            </div> 
          </div>

          <div ref={this.box} className="leaner-course-sltd select" >
            <div className={`custom-select ${this.state.isOPenDropDown?'active':''}`} onClick={this.SetIsopenToggle} id="setActiveCourseName"></div>
            <ul className={`select-options ${this.state.isOPenDropDown?'show':''}`} id="leanerDropdown">
            </ul>
          </div>
        </div>

        <div className="rTableCell">
          <div className="float-r learner-report-export-txt" onClick={() => this.exportSummary()}>
            <svg xmlns="http://www.w3.org/2000/svg" width="15.737" height="13.267" viewBox="0 0 15.737 13.267">
              <g id="Group_139" data-name="Group 139" transform="translate(-1259.4 -40)">
                <path id="Path_28" data-name="Path 28" d="M2.674,5.284h7.534a.423.423,0,0,1,.419.428v5.135h1.256V5.712A1.693,1.693,0,0,0,10.208,4H2.674A1.693,1.693,0,0,0,1,5.712v9.843a1.693,1.693,0,0,0,1.674,1.712h7.534a1.682,1.682,0,0,0,1.621-1.284H10.417q-.075,0-.149,0a.409.409,0,0,1-.06,0H2.674a.423.423,0,0,1-.419-.428V5.712A.423.423,0,0,1,2.674,5.284Z" transform="translate(1258.4 36)" fill="#2e3e4e" fillRule="evenodd" opacity="0.8" />
                <path id="Union_1" data-name="Union 1" d="M-7926.283-1216.05v-.728h-2.364a1.352,1.352,0,0,1-1.354-1.351,1.354,1.354,0,0,1,1.354-1.353h2.364v-1.065a.452.452,0,0,1,.712-.368l3.165,2.249a.451.451,0,0,1,0,.734l-3.165,2.251a.447.447,0,0,1-.259.083A.452.452,0,0,1-7926.283-1216.05Z" transform="translate(9197.354 1266.51)" fill="#2e3e4e" opacity="0.8" />
                <path id="Path_30" data-name="Path 30" d="M9.979,11.852h-1.8a.676.676,0,0,1,0-1.352h1.8a.676.676,0,0,1,0,1.352Z" transform="translate(1254.647 31.266)" fill="#2e3e4e" opacity="0.8" />
                <path id="Path_31" data-name="Path 31" d="M9.979,16.852h-1.8a.676.676,0,0,1,0-1.352h1.8a.676.676,0,0,1,0,1.352Z" transform="translate(1254.647 28.394)" fill="#2e3e4e" opacity="0.8" />
                <path id="Path_32" data-name="Path 32" d="M9.979,21.852h-1.8a.676.676,0,1,1,0-1.352h1.8a.676.676,0,1,1,0,1.352Z" transform="translate(1254.647 25.521)" fill="#2e3e4e" opacity="0.8" />
                <path id="Path_33" data-name="Path 33" d="M9.979,26.852h-1.8a.676.676,0,1,1,0-1.352h1.8a.676.676,0,1,1,0,1.352Z" transform="translate(1254.647 22.649)" fill="#2e3e4e" opacity="0.8" />
              </g>
            </svg>
            Export
          </div>
        </div>
      </div>
    </div>
  </div>
  <Leanerdetails />

  <div className="leaner-report-tab">

    <div className="container-fluid">
      <div>
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className={`nav-item ${this.state.activeTabs == 'testTab' && 'active'}`} onClick={() => { this.setState({ activeTabs:'testTab'})}} >
            <a className="nav-link" id="test-tab" data-toggle="tab" href="#testreport" role="tab" aria-controls="testreport" aria-selected="true">Test Report</a>
          </li>
          <li className={`nav-item ${this.state.activeTabs == 'assingmentTab' && 'active'}`} onClick={() => { this.setState({ activeTabs: 'assingmentTab' }) }} >
            <a className="nav-link" id="assignment-tab" data-toggle="tab" href="#assignmentreport" role="tab" aria-controls="assignmentreport" aria-selected="false">Assignment Report</a>
          </li>
          <li className={`nav-item ${this.state.activeTabs == 'scomTab' && 'active'}`} onClick={() => { this.setState({ activeTabs: 'scomTab' }) }} >
            <a className="nav-link" id="scrom-tab" data-toggle="tab" href="#scromreport" role="tab" aria-controls="scromreport" aria-selected="false">Scorm Report</a>
        </li>
        </ul>
      </div>
    </div>



    <div className="leaner-report-results">
      <div className="tab-content mt-4" id="myTabContent">

        {this.state.activeTabs == 'testTab' && this.leanerTestTabs()}
        {this.state.activeTabs == 'assingmentTab' && this.leanerAssingmentTabs()}
        {this.state.activeTabs == 'scomTab' && this.leanerScomTabs()}
        

    



      </div>
    </div>
  </div>

</section>)

}
}
